export default __webpack_public_path__ + "static/media/customer.fe1a9598.svg";